import React from "react";
import { Box } from "@mui/material";
import CustomerManagementList from "./CustomerManagementList";

const CustomerList = () => {
  return (
    <Box className="container">
      <CustomerManagementList />
    </Box>
  );
};

export default CustomerList;
